// extracted by mini-css-extract-plugin
export var container = "_90-0";
export var icon = "_90-1";
export var text = "_90-2";